export default __webpack_public_path__ + "static/media/3d-room-scan.d5934b64.jpeg";